import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Credenciales inválidas o error de conexión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/40 p-4">
      <div className="w-full max-w-xs">
        <div className="flex justify-center mb-5">
          <div className="flex flex-col items-center gap-3">
            <img
              src="/logo-cooper.png"
              alt="Cooper Slip Logo"
              className="h-16 w-auto object-contain drop-shadow-sm rounded-xl"
            />
            <span className="text-lg font-bold tracking-tight text-center">Cooper Slip ACTIVO 4</span>
          </div>
        </div>

        <Card className="border-0 shadow-lg bg-background/60 backdrop-blur-xl">
          <CardHeader className="space-y-0.5 p-4 pb-2">
            <CardTitle className="text-lg text-center">Bienvenido</CardTitle>
            <CardDescription className="text-center text-xs">Ingresa tu usuario y contraseña</CardDescription>
          </CardHeader>
          <CardContent className="p-4 pt-2">
            <form onSubmit={handleSubmit} className="space-y-3" data-testid="login-form">
              {error && (
                <div
                  className="p-2 rounded-md bg-destructive/10 text-destructive text-xs font-medium"
                  data-testid="login-error"
                >
                  {error}
                </div>
              )}
              <div className="space-y-1">
                <Label htmlFor="username" className="text-xs">Usuario</Label>
                <Input
                  id="username"
                  data-testid="login-username-input"
                  type="text"
                  placeholder="Ej. admin"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="bg-background h-9"
                />
              </div>
              <div className="space-y-1">
                <Label htmlFor="password" className="text-xs">Contraseña</Label>
                <Input
                  id="password"
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="bg-background h-9"
                />
              </div>
              <Button className="w-full h-9" type="submit" disabled={loading} data-testid="login-submit-button">
                {loading ? "Iniciando sesión..." : "Iniciar sesión"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
